import { SUPPORTED_CLICK_ID_QUERY_PARAMETERS as PARAMETERS } from '~/constants/query-parameters'

/**
 * The click ID parameters of each ad platform, in order of precedence when a URL
 * carries more than one for the same platform (RVZ-28582).
 */
export const CLICK_ID_PARAMETERS_BY_PLATFORM = {
  google: [PARAMETERS.gclid, PARAMETERS.gbraid, PARAMETERS.wbraid, PARAMETERS.dclid],
  microsoft: [PARAMETERS.msclkid],
  meta: [PARAMETERS.fbclid],
  tiktok: [PARAMETERS.ttclid],
} as const
Object.freeze(CLICK_ID_PARAMETERS_BY_PLATFORM)

/**
 * The longest click-through attribution window of each ad platform. Past it, a click
 * can't earn the platform credit, and carrying its ID would only make later visits
 * look like ad clicks.
 */
export const CLICK_ID_MAX_AGE_IN_DAYS_BY_PLATFORM = {
  google: 90,
  microsoft: 90,
  meta: 7,
  tiktok: 28,
} as const satisfies Record<keyof typeof CLICK_ID_PARAMETERS_BY_PLATFORM, number>
Object.freeze(CLICK_ID_MAX_AGE_IN_DAYS_BY_PLATFORM)
